<template>
    <div id="main-container">
        <div class="page-header">
            <h1 id="page-title">Log sincronizzazioni database</h1>

            <Button
                label="Aggiorna"
                icon="pi pi-refresh"
                class="p-button-sm"
                :loading="loading"
                @click="loadJobs"
            />
        </div>

        <div v-if="loading" class="loading-box">
            Caricamento log sincronizzazioni...
        </div>

        <DataTable
            v-else
            :value="jobs"
            responsiveLayout="scroll"
            class="sync-table"
            :paginator="true"
            :rows="20"
        >
            <template #empty>
                Nessun log sincronizzazione trovato.
            </template>

            <Column field="gruppo" header="Gruppo" />
            <Column field="tipo" header="Tipo" />
            <Column field="stato" header="Stato">
                <template #body="slotProps">
                    <span :class="getStatusClass(slotProps.data.stato)">
                        {{ slotProps.data.stato }}
                    </span>
                </template>
            </Column>
            <Column field="data_inizio" header="Inizio" />
            <Column field="data_fine" header="Fine" />
            <Column field="num_tab" header="Tabelle" />
            <Column field="num_tab_sync" header="OK" />
            <Column field="num_tab_err" header="Errori" />
            <Column field="gruppo_attivo" header="Gruppo attivo">
                <template #body="slotProps">
                    {{ slotProps.data.gruppo_attivo ? 'Sì' : 'No' }}
                </template>
            </Column>

            <Column field="prossimo_avvio" header="Prossimo avvio" />
            <Column header="Azioni">
                <template #body="slotProps">
                    <Button
                        label="Dettaglio"
                        icon="pi pi-eye"
                        class="p-button-sm"
                        @click="openJobDetails(slotProps.data)"
                    />
                </template>
            </Column>
        </DataTable>

        <Dialog
            :header="selectedJob ? 'Dettaglio job #' + selectedJob.id : 'Dettaglio job'"
            v-model:visible="showDetailsModal"
            :modal="true"
            :style="{ width: '850px' }"
        >
            <div v-if="loadingDetails" class="loading-box">
                Caricamento dettaglio tabelle...
            </div>

            <DataTable
                v-else
                :value="jobTables"
                responsiveLayout="scroll"
                class="sync-table"
            >
                <template #empty>
                    Nessun dettaglio tabella trovato.
                </template>

                <Column field="tabella" header="Tabella" />
                <Column field="stato" header="Stato">
                    <template #body="slotProps">
                        <span :class="getStatusClass(slotProps.data.stato)">
                            {{ slotProps.data.stato }}
                        </span>
                    </template>
                </Column>
                <Column field="messaggio" header="Messaggio" />
                <Column field="data_creazione" header="Data" />
            </DataTable>
        </Dialog>
    </div>
</template>

<script>
import DatabaseSyncService from './database-sync-service';

export default {
    name: 'DatabaseSyncJobLogs',

    data() {
        return {
            loading: false,
            loadingDetails: false,
            jobs: [],
            jobTables: [],
            selectedJob: null,
            showDetailsModal: false
        };
    },

    mounted() {
        this.loadJobs();
    },

    methods: {
        async loadJobs() {
            this.loading = true;

            try {
                const response = await DatabaseSyncService.getLatestJobsByGroup();

                this.jobs = response.data.data || [];
            } catch (error) {
                console.error(error);
                alert('Errore durante il caricamento dei log sincronizzazione');
            } finally {
                this.loading = false;
            }
        },

        async openJobDetails(job) {
            this.selectedJob = job;
            this.jobTables = [];
            this.showDetailsModal = true;
            this.loadingDetails = true;

            try {
                const response = await DatabaseSyncService.getJobTables(job.id);
                this.jobTables = response.data.data || [];
            } catch (error) {
                console.error(error);
                alert('Errore durante il caricamento del dettaglio job');
            } finally {
                this.loadingDetails = false;
            }
        },

        getStatusClass(status) {
            if (status === 'completato' || status === 'ok') {
                return 'sync-status sync-status-ok';
            }

            if (status === 'errore') {
                return 'sync-status sync-status-error';
            }

            if (status === 'in_corso') {
                return 'sync-status sync-status-running';
            }

            return 'sync-status';
        }
    }
};
</script>

<style>
.page-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    margin-bottom: 20px !important;
}

.loading-box {
    padding: 20px !important;
    background: #ffffff !important;
    border-radius: 6px !important;
}

.sync-table .p-datatable-thead > tr > th {
    background-color: #f4f4f4 !important;
    color: #000000 !important;
    font-weight: 700 !important;
    border: 1px solid #dcdcdc !important;
}

.sync-table .p-column-title {
    color: #000000 !important;
}

.sync-status {
    display: inline-block !important;
    padding: 4px 8px !important;
    border-radius: 12px !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
}

.sync-status-ok {
    background-color: #dff5e1 !important;
    color: #1b7f32 !important;
}

.sync-status-error {
    background-color: #fde2e2 !important;
    color: #b00020 !important;
}

.sync-status-running {
    background-color: #fff4d6 !important;
    color: #9a6a00 !important;
}
</style>